import React from 'react';
import SharedModal, { SharedModalSize } from './SharedModal';
import './ConfirmModal.css';

export type ConfirmModalVariant = 'danger' | 'warning' | 'default';

export interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  /** Return false to keep the modal open (e.g. validation or API error handled inline). */
  onConfirm: () => void | boolean | Promise<void | boolean>;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ConfirmModalVariant;
  loading?: boolean;
  size?: SharedModalSize;
  overlayClassName?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'danger',
  loading = false,
  size = 'sm',
  overlayClassName,
}) => {
  const handleConfirm = async () => {
    try {
      const result = await onConfirm();
      if (result !== false) {
        onClose();
      }
    } catch {
      // Keep modal open; caller can surface an error inside the modal body.
    }
  };

  const footer = (
    <div className="confirm-modal__footer">
      <button
        type="button"
        className="confirm-modal__btn confirm-modal__btn--cancel"
        onClick={onClose}
        disabled={loading}
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        className={`confirm-modal__btn confirm-modal__btn--confirm confirm-modal__btn--${variant}`}
        onClick={handleConfirm}
        disabled={loading}
      >
        {loading ? 'Please wait…' : confirmLabel}
      </button>
    </div>
  );

  return (
    <SharedModal
      open={open}
      onClose={onClose}
      title={title}
      size={size}
      variant={variant === 'danger' ? 'danger' : 'default'}
      footer={footer}
      showCloseButton={true}
      closeOnOverlayClick={!loading}
      overlayClassName={overlayClassName}
    >
      <div className="confirm-modal__message">{message}</div>
    </SharedModal>
  );
};

export default ConfirmModal;
